import { post } from "@/lib/api";

/**
 * Request a Presigned URL for media upload
 * @param {Object} payload 
 * @param {string} payload.file_name - The original name of the file
 * @param {string} payload.file_type - The MIME type of the file
 * @param {string} [payload.context="diy"] - 'profile' or 'diy' (Defaults to 'diy')
 * @param {string} [payload.reference_id] - Required if context is 'diy' (template slug or project ID)
 * @param {string} [payload.old_file_key] - Optional, the file_key of a previous upload to replace/delete
 */
export async function getPresignedUrl(payload, options = {}) {
  return post("/upload/presigned-url", payload, { useAuth: true, useApiKey: true, ...options });
}

/**
 * Upload a file directly to Cloudflare R2 using the presigned URL
 * @param {string} uploadUrl - The upload_url returned from getPresignedUrl
 * @param {File|Blob} file - The actual File or Blob object
 * @param {Function} [onProgress] - Optional callback for upload progress (0-100)
 */
export function uploadToCloud(uploadUrl, file, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", uploadUrl, true);
    xhr.setRequestHeader("Content-Type", file.type);

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) {
        const percent = Math.round((e.loaded / e.total) * 100);
        onProgress(percent);
      }
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr.response);
      } else {
        reject(new Error("Failed to upload file to cloud storage"));
      }
    };

    xhr.onerror = () => reject(new Error("Network error during upload"));
    xhr.send(file);
  });
}

/**
 * Build the actual media URL string so the browser can request it via Next.js proxy
 * @param {string} token - The encrypted token
 */
export function getMediaUrl(token) {
  const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL || "/api/backend";
  return `${baseUrl.replace(/\/$/, "")}/media/${token}`;
}